import { render, staticRenderFns } from "./TaskNotification.vue?vue&type=template&id=de4b5bea&lang=pug"
import script from "./TaskNotification.vue?vue&type=script&lang=js"
export * from "./TaskNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports